import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import style from '@aytm/app/swidget/base/questions/Ecommerce/Target/components/Rating.module.scss'
const PRIMARY_COLOR = '#333'
interface IRatingProps {
  rating: number
  size?: 'big' | 'small'
  appearence?: 'single' | 'multiple'
}

const Rating = ({ rating, size = 'small', appearence = 'multiple' }: IRatingProps) => {
  const decimal = Math.round((rating % 1) * 10) / 10
  const fullStars = Math.floor(rating)
  const finalFullStars = decimal >= 0.8 ? fullStars + 1 : fullStars
  const hasHalfStar = decimal >= 0.3 && decimal <= 0.7
  const total: number[] = Array.from(Array(5), () => 0)

  if ('single' === appearence) {
    return (
      <>
        <span className={style.rating}>{rating}</span>
        <EmptyLink color="#CC0000">
          <svg
            preserveAspectRatio="xMinYMin meet"
            version="1.1"
            viewBox="0 0 46 44"
            style={{ width: 'small' === size ? '12px' : '16px', height: 'small' === size ? '12px' : '16px' }}
          >
            <polygon
              className="starFill"
              fill={PRIMARY_COLOR}
              points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
            />
            <path
              className="starStroke"
              fill={PRIMARY_COLOR}
              d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
            />
          </svg>
        </EmptyLink>
      </>
    )
  }

  return (
    <EmptyLink color="#CC0000">
      <svg
        preserveAspectRatio="xMinYMin meet"
        version="1.1"
        viewBox="0 0 250 50"
        style={{ width: `${'small' === size ? '75px' : '96px'}`, height: `${'small' === size ? '12px' : '16px'}` }}
      >
        {total.map((_, index) => (
          <g key={index} transform={`translate(${index * 62}, 0)`}>
            <polygon
              className="starFill"
              fill="#f5f5f5"
              points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
            />

            {index < finalFullStars && (
              <polygon
                className="starFill"
                fill={PRIMARY_COLOR}
                points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
              />
            )}
            {index === fullStars && hasHalfStar && (
              <clipPath id={`halfStar-${index}`}>
                <rect x="0" y="0" width="23" height="50" />
              </clipPath>
            )}
            {index === fullStars && hasHalfStar && (
              <polygon
                className="starFill"
                fill={PRIMARY_COLOR}
                points="18.3804527 17.5538712 3.57341884 17.5538227 15.5524968 26.0839651 10.9490362 39.9740092 22.9998469 31.3908403 35.0505989 39.9718199 30.4479632 26.0860159 42.4267599 17.5548252 27.6195159 17.5548252 22.9999796 3.61638342"
                clipPath={`url(#halfStar-${index})`}
              />
            )}
            <path
              className="starStroke"
              d="M23,0.125 C23.548595,0.125 24.0427295,0.43633439 24.2838822,0.916322114 L24.3620682,1.10394446 L29.1238205,15.4714919 L44.4834654,15.4714919 C45.1040547,15.4669374 45.6559866,15.865131 45.847289,16.4554281 C46.0385914,17.0457252 45.8251153,17.6918966 45.3197896,18.0521171 L32.9094637,26.8906392 L37.659289,41.2205029 C37.8492978,41.8088537 37.6399199,42.4526832 37.1401666,42.8167858 C36.6404132,43.1808884 35.963305,43.1829213 35.4613737,42.8218261 L23,33.9484823 L10.5391034,42.8237342 C10.0368835,43.1855662 9.35893267,43.1835738 8.85884877,42.8187963 C8.35876487,42.4540187 8.14989861,41.8091377 8.34118809,41.2205029 L13.0910134,26.8887312 L0.680210361,18.0511631 C0.174884727,17.6909426 -0.0385914063,17.0447712 0.152710977,16.4544741 C0.34401336,15.864177 0.89594535,15.4659834 1.51653456,15.4705379 L16.8761795,15.4705379 L21.6379318,1.10394446 C21.8345878,0.519032587 22.3828306,0.125 23,0.125 Z M22.9999796,3.61638342 L18.3804527,17.5538712 L3.57341884,17.5538227 L15.5524968,26.0839651 L10.9490362,39.9740092 L22.9998469,31.3908403 L35.0505989,39.9718199 L30.4479632,26.0860159 L42.4267599,17.5548252 L27.6195159,17.5548252 L22.9999796,3.61638342 Z"
              fill={PRIMARY_COLOR}
            />
          </g>
        ))}
      </svg>
    </EmptyLink>
  )
}

export default Rating
